/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Rozmawiaj, poznawaj i spotykaj nowych ludzi",
      "Nieprawidłowy numer telefonu",
      "Get the app",
      "Kontynuuj z Apple",
      "Kontynuuj przez Facebook",
      "Kontynuuj przez Google",
      "Zaloguj się",
      "Zapisz się",
      "Aby kontynuować, wprowadź znaki, które widzisz w polu poniżej.",
      "Dalej",
      "Wprowadź znaki",
      "Kontrola bezpieczeństwa",
      "Załaduj ponownie",
      "Utwórz nowe hasło, które z łatwością zapamiętasz:",
      "Aktualizuj",
      "Potwierdź hasło",
      "Hasło musi się składać z minimum {{num}} [[characters:num]]",
      "Hasło",
      "Utwórz nowe hasło",
      "Badoo - Blog",
      "Praca",
      "Czat",
      "Miasta",
      "Zarządzaj cookies",
      "Prawa autorskie © 2006 – obecnie. Bumble. Wszelkie prawa zastrzeżone.",
      "Apple i logo Apple są znakami towarowymi firmy Apple Inc.{{__EOL__}}Google Play jest znakiem towarowym firmy Google LLC.",
      "Pobierz",
      "Facebook",
      "Obserwuj nas",
      "Centrum pomocy",
      "Instagram",
      "Język",
      "LinkedIn",
      "Przegląd",
      "Badoo to część Bumble Inc.",
      "Polityka prywatności",
      "Safety Centre",
      "Mapa witryny",
      "Oświadczenie w spr. Ustawy o Współczesnym Niewolnictwie",
      "Regulamin",
      "Twitter",
      "Wpisz swój adres e-mail lub numer telefonu komórkowego, a wyślemy Ci instrukcje dotyczące tworzenia nowego hasła.",
      "Stwórz nowe hasło",
      "Wpisz adres e-mail lub numer telefonu",
      "Zapomniałeś hasło",
      "Modelki wykorzystane wyłącznie w celach poglądowych",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Nie musisz czekać na dopasowanie.{{__EOL__}}{{__EOL__}}Od razu przejdź do sedna sprawy, angażując się w głębszą rozmowę. Tak, aby naprawdę się poznać.",
      "Czas na rozmowę teraz?",
      "Rejestrując się, zgadzasz się z naszym <a class=\"link\" href=\"{{terms_url}}\">Regulaminem</a>. Dowiedz się, jak wykorzystujemy Twoje dane w naszej <a class=\"link\" href=\"{{privacy_url}}\">Polityce prywatności</a>",
      "Dzięki temu, możesz pokazać prawdziwego siebie jeszcze bardziej, <br />aby randkowanie było przyjemne.",
      "Randkowanie z pewnością siebie. To jest to!",
      "Lub",
      "Masz już konto?",
      "Zapisz się za pomocą e-maila lub nr telefonu",
      "Niech randkowanie spełni Twój cel.{{__EOL__}}Nie musisz przepraszać.",
      "Chcecie jedynie porozmawiać? No to OK.{{__EOL__}}Gotowi na stabilizację? No to super.{{__EOL__}}{{__EOL__}}Jeśli zmienicie zdanie, macie do tego prawo.",
      "Chcę się umówić",
      "Szukam miłości",
      "Chcę porozmawiać",
      "Poznaj osoby, które chcą tego samego.",
      "{{name}}, {{age}}",
      "Twoje bezpieczeństwo to nasz najważniejszy priorytet.",
      "Nasze Safety Centre to centrum wiedzy, które zawiera wszelkie wsparcie, którego potrzebujesz, aby bezpiecznie umawiać się na randki.",
      "Odwiedź Safety Centre",
      "Bezpieczeństwo <br/>ponad wszystko.",
      "Od pierwszej chwili czuło się, że to wyjdzie...”",
      "„Na początku nie chodziło mi o nic poważnego...\"",
      "Naszą poradą dla wszystkich korzystających z apki Badoo to „Najelpiej po prostu być sobą...\"",
      "Historie sukcesu Badoo",
      "Sprawdź więcej historii",
      "{{num}}__CUT__Ranking",
      "Sklep Apple App",
      "Zaufaj nam. Dopasowaliśmy miliony użytkowników, i jeszcze więcej.",
      "Ponad {{num}} mln.__CUT__pobrań",
      "ponad {{num}} mln.",
      "Sklep Google Play",
      "Wiemy, co robić.",
      "Zaloguj się za pomocą e-maila lub nr tel.",
      "Wprowadź hasło",
      "Zapomniałeś hasło?",
      "Zapisz się",
      "Nie masz konta?",
      "Zaloguj się",
      "Zapisz się"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "few": [
                  "znaki",
                  "znaków",
                  "znakom",
                  "znaki",
                  "znakach",
                  "znakami",
                  "znaki"
            ],
            "many": [
                  "znaków",
                  "znaków",
                  "znakom",
                  "znaków",
                  "znakach",
                  "znakami",
                  "znaków"
            ],
            "plural": [
                  "znaków",
                  "znaków",
                  "znaków",
                  "znaków",
                  "znaków",
                  "znaków",
                  "znaków"
            ],
            "singular": [
                  "znak",
                  "znaku",
                  "znakowi",
                  "znak",
                  "znaku",
                  "znakiem",
                  "znak"
            ]
      },
      "day": {
            "few": [
                  "dni",
                  "dni",
                  "dniom",
                  "dni",
                  "dniach",
                  "dniami",
                  "dni"
            ],
            "many": [
                  "dni",
                  "dni",
                  "dniom",
                  "dni",
                  "dniach",
                  "dniami",
                  "dni"
            ],
            "plural": [
                  "dni",
                  "dni",
                  "dni",
                  "dni",
                  "dni",
                  "dni",
                  "dni"
            ],
            "singular": [
                  "dzień",
                  "dnia",
                  "dniowi",
                  "dzień",
                  "dniu",
                  "dniem",
                  "dzień"
            ]
      },
      "hour": {
            "few": [
                  "godziny",
                  "godzin",
                  "godzinom",
                  "godziny",
                  "godzinach",
                  "godzinami",
                  "godziny"
            ],
            "many": [
                  "godzin",
                  "godzin",
                  "godzinom",
                  "godzin",
                  "godzinach",
                  "godzinami",
                  "godzin"
            ],
            "plural": [
                  "godzin",
                  "godzin",
                  "godzin",
                  "godzin",
                  "godzin",
                  "godzin",
                  "godzin"
            ],
            "singular": [
                  "godzina",
                  "godziny",
                  "godzinie",
                  "godzinę",
                  "godzinie",
                  "godziną",
                  "godzina"
            ]
      },
      "minute": {
            "few": [
                  "min.",
                  "min.",
                  "min.",
                  "min.",
                  "min.",
                  "min.",
                  "min."
            ],
            "many": [
                  "min.",
                  "min.",
                  "min.",
                  "min.",
                  "min.",
                  "min.",
                  "min."
            ],
            "plural": [
                  "min.",
                  "min.",
                  "min.",
                  "min.",
                  "min.",
                  "min.",
                  "min."
            ],
            "singular": [
                  "min.",
                  "min.",
                  "min.",
                  "min.",
                  "min.",
                  "min.",
                  "min."
            ]
      },
      "month": {
            "few": [
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies."
            ],
            "many": [
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies."
            ],
            "plural": [
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies."
            ],
            "singular": [
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies."
            ]
      },
      "second": {
            "few": [
                  "sekundy",
                  "sekund",
                  "sekundom",
                  "sekundy",
                  "sekundach",
                  "sekundami",
                  "sekundy"
            ],
            "many": [
                  "sekund",
                  "sekund",
                  "sekundom",
                  "sekund",
                  "sekundach",
                  "sekundami",
                  "sekund"
            ],
            "plural": [
                  "sekund",
                  "sekund",
                  "sekund",
                  "sekund",
                  "sekund",
                  "sekund",
                  "sekund"
            ],
            "singular": [
                  "sekunda",
                  "sekundy",
                  "sekundzie",
                  "sekundę",
                  "sekundzie",
                  "sekundą",
                  "sekundo"
            ]
      },
      "year": {
            "few": [
                  "lata",
                  "lat",
                  "latom",
                  "lata",
                  "latach",
                  "latami",
                  "lata"
            ],
            "many": [
                  "lat",
                  "lat",
                  "latom",
                  "lat",
                  "latach",
                  "latami",
                  "lat"
            ],
            "plural": [
                  "lat",
                  "lat",
                  "lat",
                  "lat",
                  "lat",
                  "lat",
                  "lat"
            ],
            "singular": [
                  "rok",
                  "roku",
                  "rokowi",
                  "rok",
                  "roku",
                  "rokiem",
                  "rok"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
